import * as types from '../mutation-types';

const state = {
  instanceList: null,
  retailInstanceList: null,
  subnetList: null,
  eipList: null,
  sbwList: null,
  vpcList: null,
  slbList: null,
  routeTablesList: null,
  vpcInstanceList: null,
  sshList: null,
  ipv6AddressList: null,
  ipv6GatewayList: null,
  cpsBandwidthPackageList: null,
  peerConnList: null,
  imageList: null,
  gameInstanceList: null
};

const getters = {
  customInfo: state => state
};

const mutations = {
  [types.GET_CUSTOMINFO](state, res) {
    // eslint-disable-next-line
    for (const key in res.value) {
      // eslint-disable-next-line
      for (const subKey in res.value[key]) {
        if (res.value[key][subKey] == 'true' || res.value[key][subKey] == true) {
          res.value[key][subKey] = true;
        } else {
          res.value[key][subKey] = false;
        }
      }
    }
    state[res.type] = res.value;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/customInfo.js